import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import { categories, mangaList } from '@/mocks/mangaData';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const [activeSlug, setActiveSlug] = useState(slug || 'lianai');

  const filteredManga = mangaList.filter((m) => m.category === activeSlug);

  const handleCategoryChange = (newSlug: string) => {
    setActiveSlug(newSlug);
    window.history.replaceState(null, '', `/category/${newSlug}`);
  };

  return (
    <Layout>
      <div className="pt-20 pb-14 md:pb-20 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-900 font-medium">分类浏览</span>
          </nav>

          <div className="mb-10">
            <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
              韩国漫画分类浏览
            </h1>
            <p className="text-sm text-foreground-500">按题材筛选你喜欢的韩国漫画</p>
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-10">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryChange(cat.slug)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
                }`}
              >
                <i className={cat.icon}></i>
                {cat.name}
              </button>
            ))}
          </div>

          <div className="mb-10">
            <h2 className="text-lg font-bold font-heading text-foreground-900 mb-6">
              {currentCategory.name}漫画精选（{filteredManga.length}部）
            </h2>

            {filteredManga.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {filteredManga.map((manga) => (
                  <Link
                    key={manga.id}
                    to={`/article/${manga.id === 'm2' ? 'a2' : manga.id === 'm8' ? 'a3' : manga.id === 'm5' ? 'a3' : manga.id === 'm1' ? 'a1' : manga.id === 'm4' ? 'a1' : manga.id === 'm6' ? 'a4' : manga.id === 'm10' ? 'a2' : manga.id === 'm3' ? 'a2' : manga.id === 'm7' ? 'a2' : manga.id === 'm9' ? 'a5' : manga.id === 'm11' ? 'a4' : 'a5'}`}
                    className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
                  >
                    <div className="aspect-[3/4] overflow-hidden">
                      <img
                        src={manga.cover}
                        alt={manga.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="text-base font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                        {manga.title}
                      </h3>
                      <p className="text-xs text-foreground-500 mt-1">{manga.author}</p>
                      <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
                        {manga.description}
                      </p>
                      <div className="flex items-center gap-2 mt-3 flex-wrap">
                        <div className="flex items-center gap-0.5">
                          <i className="ri-star-fill text-accent-500 text-xs"></i>
                          <span className="text-xs font-medium text-foreground-700">{manga.rating}</span>
                        </div>
                        <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap ${
                          manga.status === '已完结'
                            ? 'bg-secondary-100 text-secondary-700'
                            : 'bg-primary-100 text-primary-700'
                        }`}>
                          {manga.status}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-background-200">
                  <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无推荐作品</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}